<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-form
        @submit.prevent="roleSave()"
        ref="form"
        v-model="valid"
        lazy-validation
    >
      <v-row>
        <v-col cols="12" md="12">
          <v-card>
            <v-card-title>
              <div v-if="edit_role_id">
                Edit Role & Permission
              </div>
              <div v-else>
                Add Role & Permission
              </div>
            </v-card-title>
            <v-col>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                      v-model="role.name"
                      label="Role Name"
                      hide-details="auto"
                      outlined
                      dense
                      :loading="loading_status"
                  ></v-text-field>
                </v-col>
              </v-row>
              <h4 class="mt-2 mb-2">Select Permissions</h4>
              <v-row>
                <v-col cols="12" v-for="(parent,index) in permissions" :key="index">
                  <v-checkbox
                      v-model="selectedPermissions"
                      :label="parent.name"
                      :value="parent.id"
                      color="primary"
                      class="custom-checkbox"
                  ></v-checkbox>
                  <v-row class="ms-2">
                    <v-col cols="2" v-for="(child,index) in (parent.child_permissions)" :key="index">
                      <v-checkbox
                          v-model="selectedPermissions"
                          :label="child.name"
                          :value="child.id"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-row style="margin-left: 10px; margin-right: 10px; margin-bottom: 10px" align="center" justify="space-around">
              <v-btn style="margin-top: 2px; margin-bottom: 5px;" depressed color="primary" type="submit">
                Submit
              </v-btn>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<style scoped></style>
<style>
.custom-checkbox .v-label {
  color: blue;
}
</style>
<script>
import atshq from "../../../js/setup";

export default {
  data() {
    return {
      valid: true,
      loading_status: true,
      edit_role_id: this.$route.params.id,
      permissions: [],
      role: {
        'id': '',
        'name':'',
        user_id: localStorage.getItem("userId"),
      },
      selectedPermissions: [],
      items: [
        {text: "Dashboard", disabled: false, href: "/",},
        {text: "Users & Roles", disabled: true, href: "/",},
      ],
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      if (this.edit_role_id){
        atshq
            .get("users/roles/" + this.edit_role_id + "/edit")
            .then((response) => {
              // JSON responses are automatically parsed.
              this.role = response.data.role;
              this.permissions = response.data.permissions;
              this.selectedPermissions = response.data.selectedPermissions
              console.log(this.permissions)
              this.loading_status = false;
            })
            .catch((e) => {
              // this.errors.push(e);
              this.$noty.error("Oops, something went wrong!");
              this.$noty.error(" " + e);
            });
      } else {
        atshq
            .get("users/roles/create")
            .then((response) => {
              // JSON responses are automatically parsed.
              this.permissions = response.data.permissions;
              this.loading_status = false;
            })
            .catch((e) => {
              // this.errors.push(e);
              this.$noty.error("Oops, something went wrong!");
              this.$noty.error(" " + e);
            });
      }

    },
    roleSave() {
      let submitUrl = this.role.id ? "users/roles/" + this.role.id : "users/roles";
      if (this.role.id) {
        atshq
            .put(submitUrl, {
              role: this.role,
              permissions: this.selectedPermissions,
            })
            .then((response) => {
              this.loading_status = false;
              this.$noty.success(response.data.message);
              this.$router.push("/users/role-list");
            })
            .catch((e) => {
              this.$noty.error(" " + e.response.data.message);
            });
      } else {
        atshq
            .post(submitUrl, {
              role: this.role,
              permissions: this.selectedPermissions,
            })
            .then((response) => {
              // JSON responses are automatically parsed.
              this.loading_status = false;
              this.$noty.success(response.data.message);
              this.$router.push("/users/role-list");
            })
            .catch((e) => {
              this.$noty.error(" " + e.response.data.message);
            });
      }
    },
  },
};
</script>